import React, { Component } from 'react';

export const ShowLink = ({id}) => {
  return(
    <div className="media-right">
      <a href={`/admin/walk_in_entries/${id}/`}>
        View <i className="fa fa-id-card-o" aria-hidden="true"></i>
      </a>
    </div>
  )

}

export default ShowLink
